import React, { Component, Fragment } from "react";
import productPic from "../../assets/images/no-product-image.png";

//services
import { PermissionServices, UtilityService , FileUploadService } from "../../services";

//components
import Field from "../../components/Common/Field/Field";
import PageHeader from "../../components/Page/PageHeader/PageHeader";
import Button from '../../components/Buttons/Button'
import ImageTopLeft from '../../components/ImageTopLeft'
import Loading from '../../components/Common/Loading'

class Employee extends Component {
  state = {
    action: "",
    _id: "",
    disabled: false,
    employee : {
      firstName : "",
      lastName : "",
      userId : "",
      password : "",
      active : false,
      profilePicture : "",
      role : null,
    },

    firstName: "",
    lastName: "",
    userId: "",
    password: "",
    confirmPassword : "",
    // roleName: "",
    roleId: null,
    active: false,
    image: "",
    imageURL: "",
    allGroups: false,
    roleList : [],
    isLoading : false,
  };

  componentWillMount() {
    const { action, _id } = this.props.location.state;
    this.setState({
      isLoading : true
    })
    PermissionServices.listRoles(1)
      .then(response => {
        if (response.status === 200) {
           let roleList = []
           response.text.data.roleList.map((data) =>{
               roleList.push({ label : data.roleName, value : data._id})
           }) 
          this.setState({ roleList , isLoading : false });
        }
      })
      .catch(error => this.props.getalertMessage("error",error.toString()));
    if (action == "view") {
      this.setState({ disabled : true });
    }

    if (action == "edit" || action == "view") {
      this.setState({
        isLoading : true
      })
      PermissionServices.getEmploye(_id)
        .then(async response => {
          if (response.status === 200) {
            let employee = {...response.text.data}
            this.setState({
              employee,
              isLoading : false
            });
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage('error',error.toString()));
    }

    this.setState({ action, _id });
  }
  createEmploye = () => {
    if(this.state.employee.password !== "" && this.state.employee.confirmPassword !== ""){
        if(this.state.employee.password !== this.state.employee.confirmPassword){
          this.props.getalertMessage("error",'Password not matching')
          return false
        }
    }
    if (
      this.state.employee.firstName !== ""&&
      this.state.employee.lastName !== ""&&
      this.state.employee.userId !== ""&&
      this.state.employee.roleId !== null
      // this.state.active !== "" 
    ) {
      if (this.state.action === "add") {
        this.setState({
          isLoading : true
        })
          PermissionServices.createEmploye(this.state.employee).then(response => {
              if (response.status === 200) {
                
                this.props.getalertMessage(
                  "success",
                  response.text.message
                );
                // this.props.history.push('/listemploye')
              }else if (response.status == 401 ) {
                this.props.unauthorisedFunc()
              } 
              else {
                this.props.getalertMessage("error", response.text.message);
              }
              this.setState({
                isLoading : false
              })
            })
            .catch(error => {
              this.props.getalertMessage("error", error.toString());
            });
          // this.props.getalertMessage(
          //   "success",
          //   "Password and Confirm password not match"
          // );
      } else if (this.state.action === "edit") {
          let employee = {...this.state.employee}
          employee._id = this.state._id
          this.setState({
            isLoading : true
          })
          PermissionServices.updateEmploye(employee)
            .then(response => {
              if (response.status === 200) {
                this.props.getalertMessage(
                  "success",
                  response.text.message
                );
                // this.props.history.push('/listemploye')
              }else if (response.status == 401 ) {
                this.props.unauthorisedFunc()
              } 
              else {
                this.props.getalertMessage("error", response.text.message);
              }
              this.setState({
                isLoading : false
              })
            })
            .catch(error => this.props.getalertMessage('error',error.toString()));
      }
    } else {
      this.props.getalertMessage('error','Fill Mantadary Fields')
    }
  };

  fileUpload = file => {
    FileUploadService.uploadFile(file[0], 'employee')
    .then(response => {
      if (response.status === 200) {
        let employee = {...this.state.employee}
        employee.profilePicture = response.text.data.url
        this.setState({
          employee
        });
      } else if (response.status === 401) {
        this.props.unauthorisedFunc();
      } 
    })
    .catch(error => this.props.getalertMessage('error',error.toString()));
  };

  removeImage = () => {
    let employee = {...this.state.employee}
    employee.profilePicture = ""
    this.setState({
      employee
    });
  }

  _handleInputChange = (name,value) => {
    let employee = {...this.state.employee}
    employee[name] =  value
    this.setState({ employee })
  }

  render() {
    const { firstName , lastName , userId , active , password , confirmPassword , profilePicture , role } = this.state.employee
    return (
      <Fragment>
        {this.state.isLoading && <Loading />}
        <div class="right-section bg-white">
          <div class="row nopadding">
            <div class="col-md-12 nopadding">
                <PageHeader 
                    history = {this.props.history}
                    header = {"PERMISSION DETAILS"}
                />
                <div class="col-md-3">
                  <div class="col-md-12">
                  <ImageTopLeft
                      image = {profilePicture}
                      removeImage = {this.removeImage}
                      fileUpload = {this.fileUpload}
                  />
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="col-md-3">
                    <Field
                      isFormGroup={true}
                      inputType="text"
                      inputName="firstName"
                      value={firstName}
                      label ={"First Name"}
                      onChange={this._handleInputChange}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-3 ">
                    <Field
                      isFormGroup={true}
                      inputType="text"
                      inputName="lastName"
                      value={lastName}
                      label ={"Last Name"}
                      onChange={this._handleInputChange}
                      disabled={this.state.disabled}
                    />
                  </div>

                  <div class="col-md-3">
                    <Field
                      isFormGroup={true}
                      inputType="text"
                      inputName="userId"
                      value={userId}
                      label ={"User ID"}
                      onChange={this._handleInputChange}
                      disabled={this.state.disabled}
                    />
                  </div>
                  {this.state.action !== "view" && (
                    <Fragment>
                      <div class="col-md-3">
                        <Field
                            isFormGroup={true}
                            inputType="password"
                            inputName="password"
                            value={password}
                            label ={"Password"}
                            onChange={this._handleInputChange}
                            disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-3">
                        <Field
                            isFormGroup={true}
                            inputType="password"
                            inputName="confirmPassword"
                            value={confirmPassword}
                            label ={"Confirm Password"}
                            onChange={this._handleInputChange}
                            disabled={this.state.disabled}
                        />
                      </div>
                    </Fragment>
                  )}

                  <div class="col-md-3">
                    <Field
                      isFormGroup={true}
                      inputType="select"
                      inputName="role"
                      value={role}
                      options={this.state.roleList}
                      label ={"Role Name"}
                      onChange={this._handleInputChange}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-3">
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="active"
                      label="Active"
                      value={active}
                      onChange={this._handleInputChange}
                      disabled={this.state.disabled}
                    />
                  </div>
                  {/* <div class="col-md-3">
                    <div class="form-group">
                      <label for="name">In All Groups</label>
                      {this.state.action !== "view" ? (
                        <select
                          class="form-control"
                          onChange={e =>
                            this.setState(
                              { allGroups: e.target.value },
                              
                            )
                          }
                          value={this.state.allGroups}
                        >
                          <option value={true}>true</option>
                          <option value={false}>false</option>
                        </select>
                      ) : (
                        <input
                          type="text"
                          class="form-control"
                          disabled = {this.state.disabled}
                          value={this.state.allGroups}
                        />
                      )}
                    </div>
                  </div> */}
                  <div class="col-md-12 profile-btn text-center">
                    <button
                      type="button"
                      class="primary "
                      name="button"
                      onClick={() => this.createEmploye()}
                    >
                      {this.state.action === "add"
                        ? "ADD"
                        : this.state.action === "edit"
                        ? "EDIT"
                        : "VIEW"}{" "}
                      Details
                    </button>{" "}
                    <Button 
                      buttonType = {"cancel"}
                      buttonName = {"cancel"}
                      history = {this.props.history}
                    />
                  </div>
                </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default Employee;



// WEBPACK FOOTER //
// ./src/pages/Employee/page.js